import { apiUtils } from "../../../utils/apiUtils";
import type { SyncMerchantBrandsResponse } from "../types/merchantBrand.types";

export function syncTangoMerchantBrands(): Promise<SyncMerchantBrandsResponse> {
  return apiUtils.postData<SyncMerchantBrandsResponse>(
    "/v1/portal/merchant-brand/sync-tango",
    undefined,
    "Failed to synchronize Tango merchant catalog",
  );
}
